import Fullscreen from "@coworker/apprestructured/src/task-management/components/Fullscreen/Fullscreen";
import FullscreenContent from "@coworker/apprestructured/src/task-management/components/Fullscreen/FullscreenContent/FullscreenContent";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import Breadcrumb from "../../shared/Breadcrumb/Breadcrumb";
import CloseSheetDemo from "../ComponentDemoPage/demos/CloseSheetDemo";
import MenuSheetDemo from "../ComponentDemoPage/demos/MenuSheetDemo";
import TextModalDemo from "../ComponentDemoPage/demos/TextModalDemo";
import SelectItemSheetDemo from "../ComponentDemoPage/demos/SelectItemSheetDemo";
import styles from "../shared.module.css";

function ModalsPage() {
  return (
    <Fullscreen>
      <Linkbar currentLabel="Modals & Sheets" currentAsH1 />
      <FullscreenContent className={styles["content"]}>
        <Breadcrumb
          items={[
            { label: "Components", path: "/task-management-components" },
            { label: "Modals & Sheets" },
          ]}
        />

        <FixaText tagName="h2" textStyle="Heading.XL">
          Modals & Sheets
        </FixaText>

        <CloseSheetDemo />
        <MenuSheetDemo />
        <TextModalDemo />
        <SelectItemSheetDemo />
      </FullscreenContent>
    </Fullscreen>
  );
}

export default ModalsPage;
